// Module
var code = "<surface s-col-size=\"5\"> <div class=\"c-404\"> <i class=\"glyphicon glyphicon-warning\"></i> <p>Pagina niet gevonden.</p> </div> </surface>";
// Exports
module.exports = code;